import { BodyWrapper, Flex, H5, Caption1, H6, H3, H4 } from '@components/atoms'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { BurgerMenu, MyInPlamList } from '@components/organisms'
import { SwitchBtn } from '@components/molecules'
import { colors } from '@colors'
import { move_down_gray_img, fluent_arrow_24 } from '@images'
import { check_circle_fill } from '@images/index'

const ChangeLanguageTemplate = ({ type, history }) => {
  const [currentLanguage, setCurrentLanguage] = useState('ko')

  useEffect(() => {
    const lang =
      localStorage.getItem('language')
      || (navigator.language || 'en').split('-')[0].toLowerCase()

    setCurrentLanguage(lang)
  }, [])

  const changeLanguage = lang => {
    setCurrentLanguage(lang)
    localStorage.setItem('language', lang)
    sessionStorage.setItem('isFirstLoad', 'true')
    history.push(`/`)
  }

  return (
    <>
      <BodyWrapper
        id="change_language_template"
        style={{ paddingTop: 0, paddingBottom: 64, minHeight: '100vh' }}
      >
        <TopBar>
          <PrevButton src={fluent_arrow_24} onClick={() => history.goBack()} />
        </TopBar>

        <Br />
        <Flex type="column" align="flex-start" style={{ paddingTop: 6 }}>
          <Flex
            align="center"
            justify="space-between"
            style={{ width: '100%', cursor: 'pointer' }}
            onClick={() => changeLanguage('ko')}
          >
            <H5 style={{ padding: '14px 0' }}>한국어</H5>
            {
              currentLanguage === 'ko' && (
                <img
                  src={check_circle_fill}
                  alt={'check'}
                  style={{ width: 24, height: 24 }}
                />
              )
            }
          </Flex>
          <Flex
            align="center"
            justify="space-between"
            onClick={() => changeLanguage('en')}
            style={{ width: '100%', cursor: 'pointer' }}
          >
            <H5 style={{ padding: '14px 0' }}>English</H5>
            {
              currentLanguage === 'en' && (
                <img
                  src={check_circle_fill}
                  alt={'check'}
                  style={{ width: 24, height: 24 }}
                />
              )
            }
          </Flex>
          <Flex
            align="center"
            justify="space-between"
            onClick={() => changeLanguage('vi')}
            style={{ width: '100%', cursor: 'pointer' }}
          >
            <H5 style={{ padding: '14px 0' }}>Tiếng Việt</H5>
            {
              currentLanguage === 'vi' && (
                <img
                  src={check_circle_fill}
                  alt={'check'}
                  style={{ width: 24, height: 24 }}
                />
              )
            }
          </Flex>
        </Flex>
      </BodyWrapper>
    </>
  )
}

export default ChangeLanguageTemplate

const TopBar = styled(Flex)`
  padding-top: 16px;
  padding-bottom: 16px;
  height: 24px;
  background-color: white;
  align-items: center;
`

const PrevButton = styled.img`
  width: 32px;
  height: 32px;
  margin-right: 6px;
  margin-left: -12px;
  cursor: pointer;
`

const Header = styled(Flex)`
  padding-top: 16px;
  padding-bottom: 16px;
  height: 18px;
  justify-content: space-between;
  background-color: white;
  align-items: center;
`

const Select = styled.select`
  font-size: 12px;
  font-family: Pretendard-Medium;
  -webkit-appearance: none;
  border: none;
  color: ${colors.brown_grey};

  background-color: transparent;
  background-image: url(${move_down_gray_img});
  background-position: right;
  background-position-x: 68px;
  background-size: 12px;
  background-repeat: no-repeat;
  width: 80px;
  display: block;
  text-overflow: ellipsis;
  -webkit-padding-end: 12px;
`

const Br = styled(Flex)`
  margin-left: -20px;
  width: calc(100% + 40px);
  border-bottom: solid 1px ${colors.whitef4};
`
